import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "./app.css";
import { App } from "./App";
import { createAppDeps } from "./state/session";
import { applyTheme, getThemePreference } from "./lib/theme";
import { notifySwUpdateReady } from "./lib/swUpdate";
import { captureInstallPrompt } from "./lib/pwa";

applyTheme(getThemePreference());
// Before anything renders: Chromium offers its install prompt once, early (lib/pwa.ts).
captureInstallPrompt();

const updateSW = registerSW({
  immediate: true,
  // Prompt mode: surface the update banner; reload only when the user taps it.
  onNeedRefresh() {
    notifySwUpdateReady(() => void updateSW(true));
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App deps={createAppDeps()} />
  </StrictMode>,
);
